import React, { Component } from 'react';


class Messages extends Component {
    constructor(props) {
        super(props);
        this.messageAlert;
        this.count = this.props.messageQuotes.length-1;
        this.state = {  
            message: false,
            messageStage:false,
            count: this.props.messageQuotes.length-1,
            pop: 0 
        };
      }


    componentDidMount() {
        window.setTimeout(this.newMessage.bind(this), 5000);
    }

    componentWillUnmount() {
        // window.removeEventListener("resize", this.updateDimensions.bind(this));
        // var mapHolder = document.getElementById('mapHolder');
        // mapHolder.classList.remove('featOn');
       window.clearTimeout(this.newMessage);
      }

    newMessage(){
          window.clearTimeout(this.newMessage);
          var hiddenMessage = document.getElementById(`featQuote${this.state.count}`);
          if(hiddenMessage){
          hiddenMessage.classList.remove('hideMessage')
          }

          this.count--
          if(this.count > 0){
            
          this.setState({messageCount: this.count},()=>{
            window.setTimeout(this.newMessage, 5000);
          })
          }
          
      }

    checkMessage(e){
        
        if(e.currentTarget.classList.contains('messageFullStage'))
        {   
            e.currentTarget.classList.remove('messageFullStage')
            e.currentTarget.classList.add('removeMessageStage')
           }
        else{
       
            e.currentTarget.classList.remove('removeMessageStage')
            e.currentTarget.classList.add('messageFullStage')
            
        }
      }


    

      

     

 

 
 
    render() {
        const {messageQuotes} = this.props
         return (
             <React.Fragment>
            {messageQuotes.length?(
                messageQuotes.map((item,i)=>{
                    return(
                    <div id={`featQuote${i}`} className="messageStage relative hideMessage" onClick={this.checkMessage.bind(this)} style={{transform: `translate(0,-${(100+50)*i}%)`}}>
                        <div className="messageAlert upperT boldT centeredContent">
                            <p className="smallMessageT">New<br/>message from</p>{item.quoteName}
                        </div>
                        <div className="messageHold centerT centeredContent">
                            {item.images?(
                                <img src={item.images[0].imgURL} alt={`${item.quoteName} Photo`} ></img>
                            ):('')}
                            
                            <div className="fullStage marginBotSmall featQuoteCopy" dangerouslySetInnerHTML={{ __html : item.quoteCopy }}></div>
                            <p><span className="titleFont boldT upperT marginBotSmall messageSender">{item.quoteName}</span> <br/>on BSA’s Statement of Core Principles and Objectives</p>
                            <p className="titleFont boldT upperT blink messageDismiss">Tap to dismiss</p>
                        </div>
                </div>
                    )
                })
            ):('')}

            
            </React.Fragment>
        )
    }
  }
  
  export default Messages;


// WEBPACK FOOTER //
// ./src/components/features/feat1/messages.js